import { render, staticRenderFns } from "./PatientsFormReservations.vue?vue&type=template&id=400f92ff&"
import script from "./PatientsFormReservations.vue?vue&type=script&lang=js&"
export * from "./PatientsFormReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports